import React, { useState } from "react";
import "../BookService/bookservice.scss";
import {
	IonButton,
	IonCol,
	IonImg,
	IonLabel,
	IonLoading,
	isPlatform,
} from "@ionic/react";
import "./bodyPanel.scss";
import * as constants from "../../../constants";
import { CommonPointsForEachService } from "./commonPointsForEachService";
import { PageHeaderWithLoc } from "../BookService/pageHeadWithLoc";
import {
	getVehiclePerspectives,
	getDamageTypes,
	getBodyDamageTypes,
	clearDamageTypes,
	clearBodyDamageTypes,
	saveSelectedPartDetails,
	saveOrientationOfVehicle,
	addItemToCart,
	getCartItemsList,
} from "../../../Store/Actions";
import { connect } from "react-redux";
import AddOnModal from "../../../utils/addOnModal";
import { ToastMessage } from "../../../utils/toastMessage";
import { centroid } from "../../../utils";

export const BodyPanel: React.FC = (props: any) => {
	const [state, setState] = React.useState<any>({});
	const [partId, setPartId] = React.useState<any>("");
	const [selectedPart, setSelectedPart] = React.useState<string>();
	const [damageTypeId, setDamageTypeId] = React.useState("");
	const [showAddon, setShowAddon] = useState(false);
	const [oilGrade, setOilGrade] = useState({});
	const [selectedAddons, setSelectedAddons] = useState<any>([]);
	const [loader, setLoader] = React.useState(false);
	const [dimensions, setDimension] = React.useState({
		width: 0,
		height: 0,
	});
	const [activeIndex, setActiveIndex] = React.useState(0);
	const [toast, setToast] = React.useState({
		showToast: false,
		toastMessage: "",
		severity: "",
	});

	React.useEffect(() => {
		if (props.vehiclePerspectives.length) {
			if (!Object.keys(props.orientation).length) {
				props.saveOrientationOfVehicle(props.vehiclePerspectives[0] || {});
				getImageDimensions(props.vehiclePerspectives[0].imageUrl || {});
			} else {
				getImageDimensions(props.orientation.imageUrl || "");
			}
			if (Object.keys(props.selectedPartDetails).length) {
				const reference: any = document.getElementById(props.selectedPartDetails.partId);
				if (!!reference && reference.tagName === "polygon") {
					reference.style.fill = "#428ee2";
					reference.style.fillOpacity = 1;
					props.saveSelectedPartDetails({
						partId: reference.id,
						selectedPart: reference.getAttribute("name"),
						...props.selectedPartDetails,
					});
					props.getDamageTypes({
						partId: reference.id,
						clientName: constants.CLIENT_NAME,
					});
					reference.setAttribute("listener", "true");
				}
				if (
					!!props.selectedPartDetails.damageTypeId &&
					!!props.selectedPartDetails.partId
				) {
					props.getBodyDamageTypes({
						catalogVehicleId: props.sliderCatelogVehicleId,
						damageTypeId: props.selectedPartDetails.damageTypeId,
						partId: props.selectedPartDetails.partId,
						clientName: constants.CLIENT_NAME,
					});
				}
			}
		}

		return () => {
			setState({});
		};
	}, [props.vehiclePerspectives]);

	React.useEffect(() => {
		fetchVehiclePerspectiveData();
	}, [props.sliderCatelogVehicleId]);

	const fetchVehiclePerspectiveData = async () => {
		if (!!props.sliderCatelogVehicleId) {
			await props.getVehiclePerspectives({
				catalogVehicleId: props.sliderCatelogVehicleId,
				clientName: constants.CLIENT_NAME,
			});
		}
	};

	const saveDetailsToStore = async (key: string, value: any) => {
		await props.saveSelectedPartDetails({
			...props.selectedPartDetails,
			[key]: value,
		});
	};

	const getImageDimensions = async (value: any) => {
		const img: any = new Image();
		img.src = value;
		img.onload = function () {
			setDimension({ width: img.width, height: img.height });
		};
	};

	const clearSelectedParts = async () => {
		const parentReference: any = document.getElementById("overlay");
		const children = parentReference.children;
		for (let i = 0; i < children.length; i++) {
			let tagName = children[i].tagName;
			if (tagName === "polygon" && children[i].hasAttribute("listener")) {
				children[i].style.fill = "white";
				children[i].style.fillOpacity = 0.1;
				children[i].removeAttribute("listener");
				await props.clearDamageTypes();
				await props.clearBodyDamageTypes();
			}
		}
		await props.saveSelectedPartDetails({
			damageTypeId: "",
			selectedPart: "",
			partId: "",
		});
	};

	const highlightSelectedPart = async (event: any) => {
		const querySelectordata = document.querySelectorAll("polygon");
		[].forEach.call(querySelectordata, async (item: any) => {
			if (item.id !== event.target.id && item.hasAttribute("listener")) {
				item.style.fill = "white";
				item.style.fillOpacity = 0.1;
				item.removeAttribute("listener");
				await props.clearDamageTypes();
				await props.clearBodyDamageTypes();
			}
		});
		const reference = event.target;
		if (!event.target.hasAttribute("listener")) {
			reference.setAttribute("listener", "true");
			reference.style.fill = "#428ee2";
			reference.style.fillOpacity = 1;
			await props.saveSelectedPartDetails({
				partId: reference.id,
				selectedPart: reference.getAttribute("name"),
			});
			await props.getDamageTypes({
				partId: reference.id,
				clientName: constants.CLIENT_NAME,
			});
		}
	};

	const fillColor = () => {
		const querySelectordata = document.querySelectorAll("polygon");
		[].forEach.call(querySelectordata, (element: any) => {
			if (!element.hasAttribute("listener")) {
				element.addEventListener("click", function (event: any) {
					event.preventDefault();
					highlightSelectedPart(event);
				});
			}
		});
	};

	const changePerspective = async (value: any) => {
		await setLoader(true);
		getImageDimensions(value.imageUrl);
		await props.saveOrientationOfVehicle(value);
		if (
			Object.keys(props.selectedPartDetails).some(
				(key: any) => !!props.selectedPartDetails[key]
			)
		) {
			await props.clearDamageTypes();
		}
		if (props.bodyDamageType.length) {
			await props.clearBodyDamageTypes();
		}
		await clearSelectedParts();
	};

	const getBodyDamageDetails = async (value: any) => {
		saveDetailsToStore("damageTypeId", value);
		setDamageTypeId(value);
		await props.getBodyDamageTypes({
			catalogVehicleId: props.sliderCatelogVehicleId,
			damageTypeId: value,
			partId: props.selectedPartDetails.partId,
			pricingSegment: props.settings.pricingSegment || "standard",
			clientName: constants.CLIENT_NAME,
		});
	};

	React.useEffect(() => {
		const parent: any = document.getElementById("damage-selection-parts");
		if (parent) {
			parent.scrollLeft = 0;
			if (activeIndex === 3) {
				parent.scrollLeft = 100;
			}
			if (activeIndex === 4) {
				parent.scrollLeft = 230;
			}
		}
	}, [activeIndex]);

	const handlePrevious = async () => {
		await setActiveIndex(activeIndex - 1);
		changePerspective(props.vehiclePerspectives[activeIndex - 1]);
	};

	const handleNext = async () => {
		await setActiveIndex(activeIndex + 1);
		changePerspective(props.vehiclePerspectives[activeIndex + 1]);
	};

	const addToCart = async (serviceDetails: any, selectedPartDetails: any) => {
		try {
			const {
				service = {},
				pricing = {},
				addOnSections = [],
				serviceProviderWorkshopList = [],
			} = serviceDetails;
			// if (
			//   props.service_data
			//     .map((ele: any) => ele.serviceId)
			//     .includes(service.serviceId)
			// ) {
			//   throw Error(constants.SERVICE_ALREADY_ADDED);
			// }
			const { damageTypeId = "", partId = "", selectedPart = "" } = selectedPartDetails;
			const payload = {
				addOnsSelected: !!addOnSections.length ? [...selectedAddons, oilGrade] : [],
				appliedPrice: {
					amount: pricing.amount,
					currency: pricing.currency,
					model: props.settings.pricingSegment
						? props.settings.pricingSegment
						: pricing.model,
				},
				damageTypeId: damageTypeId || "",
				partId: partId || "",
				partDisplayName: selectedPart || "",
				recommended: true,
				serviceId: service.serviceId,
				workshopId:
					props.globalSettings.length &&
					props.globalSettings[0].workshopListingModel === "Segment"
						? ""
						: props.settings.workshopId || "",
			};
			// console.log("WID Check === 269 === ", payload);
			await props.addItemToCart(payload);
			await props.getCartItemsList();
			await props.saveSelectedPartDetails({});
			await props.saveOrientationOfVehicle({});
			await props.clearDamageTypes();
			await props.clearBodyDamageTypes();
			await props.history.push("/portal/book_service");
		} catch (e: any) {
			setToast({
				showToast: true,
				toastMessage: e.message,
				severity: "warning",
			});
			// alert(e);
		}
	};

	const handleWorkshopQualityOrModel = () => {
		// console.log("PROPS - 278 =====", props);
		const payload: any = {
			addOn:
				selectedAddons.length || Object.keys(oilGrade).length
					? [...selectedAddons, oilGrade]
					: [],
			service: {
				...props.bodyDamageType[0].service,
				partId: props.selectedPartDetails.partId,
				partDisplayName: props.selectedPartDetails.selectedPart,
				damageTypeId: props.selectedPartDetails.damageTypeId,
			},
			pricing: props.bodyDamageType[0].pricing,
			workshopQuality: props.bodyDamageType[0].pricing,
			serviceProviderWorkshopList: [],
			fromBodyPanel: true,
		};
		(props.globalSettings || []).length &&
		props.globalSettings[0].workshopListingModel === "Segment"
			? props.history.push({
					pathname: "/portal/workshop-quality",
					state: payload,
			  })
			: props.history.push({
					pathname: "/portal/select-workshop",
					state: payload,
			  });
	};

	return (
		<IonCol className="middle_panle res_bg_color" size-md="6">
			<div>
				<PageHeaderWithLoc {...props} />
			</div>
			{Boolean(props.vehiclePerspectives.length) &&
				Object.keys(props.orientation).length && (
					<>
						<div
							className={
								!!props.selectedPartDetails.damageTypeId
									? "body-panel-body no-damage-type-selected"
									: "body-panel-body height-auto"
							}
						>
							<div style={{ marginTop: isPlatform("ios") ? 20 : 0 }}>
								<IonLabel
									color="tertiary"
									className="damage-selection body-panel-upperpart"
								>
									{constants.DAMAGE_SELECTION}
								</IonLabel>
							</div>
							<div className="damage-selection-parts" id="damage-selection-parts">
								{props.vehiclePerspectives.map((ele: any, index: any) => (
									<div
										className={
											props.orientation.orientation === ele.orientation
												? "panel-type-div selected-panel"
												: "panel-type-div panel-type"
										}
										onClick={async () => {
											await setActiveIndex(index);
											await changePerspective(ele);
										}}
										tabIndex={index}
										onKeyPress={async (e: any) => {
											if (e.key === "Enter") {
												changePerspective(ele);
											}
										}}
									>
										<IonLabel
											color={
												props.orientation.orientation === ele.orientation
													? "light"
													: "tertiary"
											}
										>
											{ele.orientation.slice(0, 1) +
												ele.orientation.slice(1).toLowerCase()}
										</IonLabel>
									</div>
								))}
							</div>
							<div className="select-hotspot body-panel-upperpart">
								<IonLabel color="tertiary">{constants.SELECT_HOTSPOT}</IonLabel>
							</div>
							<div className="source_container body-panel-upperpart">
								<button
									style={{
										display: activeIndex === 0 ? "none" : "flex",
										position: "absolute",
										left: 0,
										top: "50%",
										zIndex: 10,
										background: "transparent",
										padding: 0,
									}}
									onClick={() => handlePrevious()}
									disabled={activeIndex === 0}
								>
									<img src="/images/leftArrow.svg" />
								</button>
								<img
									id="car-image"
									className="source_image"
									src={props.orientation.imageUrl}
									style={{
										width: "100%",
									}}
									onLoad={() => {
										fillColor();
										setLoader(false);
									}}
								/>
								<svg
									id="overlay"
									viewBox={`0 0 ${dimensions.width} ${dimensions.height}`}
									xmlns="http://www.w3.org/2000/svg"
									style={{
										position: "absolute",
										top: 20,
										left: 20,
										bottom: 20,
										right: 20,
									}}
								>
									<rect
										fill="rgba(255,255,255,0)"
										x="0"
										y="0"
										width="100%"
										height="100%"
									></rect>
									{props.orientation.partSections.map((ele: any, index: any) => (
										<>
											<circle
												cx={centroid(ele.sectionPoints).x}
												cy={centroid(ele.sectionPoints).y}
												r="4"
												fill={"rgba(235, 10, 30, 0.6)"}
												// fill={"rgba(124, 35, 140, 0.6)"}
												id={ele.partId}
												name={ele.displayName}
											/>
											<circle
												cx={centroid(ele.sectionPoints).x}
												cy={centroid(ele.sectionPoints).y}
												r="6"
												fill="rgba(235, 10, 30, 0.3)"
												// fill="rgba(124, 35, 140, 0.3)"
												id={ele.partId}
												name={ele.displayName}
											/>
											<polygon
												key={index}
												points={ele.sectionPoints
													.map((ele: any) => Object.values(ele).join(","))
													.join(" ")}
												fill="white"
												id={ele.partId}
												name={ele.displayName}
												fillOpacity={0.1}
												style={{
													cursor: "pointer",
												}}
											/>
										</>
									))}
								</svg>
								<button
									style={{
										display:
											activeIndex === props.vehiclePerspectives.length - 1
												? "none"
												: "flex",
										position: "absolute",
										right: 0,
										top: "45%",
										zIndex: 10,
										background: "transparent",
										padding: 0,
									}}
									onClick={() => handleNext()}
									disabled={activeIndex === props.vehiclePerspectives.length - 1}
								>
									<img src="/images/rightArrow.svg" />
								</button>
							</div>
							<div className="click-to-view-service body-panel-upperpart">
								<IonImg src="/images/info.svg" />
								<IonLabel color="tertiary" className="hotspots">
									{props.selectedPartDetails.selectedPart ||
										constants.TAP_ON_THE_HOTSPOTS_TO_VIEW_SERVICES}
								</IonLabel>
							</div>
							{Boolean(props.damageTypes.length) && (
								<div className="select-service-div body-panel-upperpart">
									<IonLabel color="tertiary" className="select-service">
										{constants.SELECT_SERVICE}
									</IonLabel>
									<div className="service-name-div">
										{props.damageTypes.map((ele: any) => (
											<IonLabel
												color={
													ele.damageTypeId === props.selectedPartDetails.damageTypeId
														? "light"
														: "tertiary"
												}
												className={
													ele.damageTypeId === props.selectedPartDetails.damageTypeId
														? "selected-service-name"
														: "service-name"
												}
												key={ele.damageTypeId}
												onClick={() => {
													getBodyDamageDetails(ele.damageTypeId);
												}}
											>
												{ele.displayName.slice(0, 1) +
													ele.displayName.slice(1).toLowerCase()}
											</IonLabel>
										))}
									</div>
								</div>
							)}
							{Boolean(props.bodyDamageType.length) && (
								<div className="margin-left-10">
									<CommonPointsForEachService
										service={props.bodyDamageType[0].service}
										showArticle={true}
									/>
								</div>
							)}
						</div>
						{Boolean(props.bodyDamageType.length) && (
							<div className="page-footer">
								<div className="sd_show_pricing">
									<IonLabel className="sd_pricing_text">
										{`${constants.PRICE_BASED_ON} ${props.settings.pricingSegment} ${constants.PRICING}`}
									</IonLabel>
								</div>
								<div className="sd_show_cost">
									<div className="sd_col">
										<IonLabel className="sd_escost">{constants.ESTIMATED_COST}</IonLabel>
										<IonLabel className="sd_price">{`${constants.RupeeSymbol} ${Number(
											props.bodyDamageType[0].pricing.amount
										)}`}</IonLabel>
									</div>
									<IonButton
										color="light"
										className="service-details-continue-button"
										onClick={() => {
											if (
												props.bodyDamageType[0].addOnSections.length &&
												props.bodyDamageType[0].addOnSections.every(
													(ele: any) => ele.items.length > 0
												)
											) {
												setShowAddon(true);
												return;
											}
											if (!!props.service_data.length) {
												addToCart(props.bodyDamageType[0], props.selectedPartDetails);
												return;
											}
											handleWorkshopQualityOrModel();
										}}
									>
										<IonLabel color="primary">
											{!!props.service_data.length
												? constants.ADD_TO_CART
												: constants.CONTINUE}
										</IonLabel>
									</IonButton>
								</div>
							</div>
						)}
					</>
				)}
			<IonLoading
				cssClass="my-custom-class"
				isOpen={loader}
				onDidDismiss={() => setLoader(false)}
				message={"Please wait..."}
				duration={5000}
			/>
			<AddOnModal
				showAddon={showAddon}
				oilGrade={oilGrade}
				selectedAddons={selectedAddons}
				setShowAddon={(value: boolean) => setShowAddon(value)}
				addOnSections={state.addOnSections}
				setOilGrade={(value: any) => setOilGrade(value)}
				setSelectedAddons={(value: any) => {
					const index = selectedAddons.findIndex(
						(ele: any) => ele.addOnId === value.addOnId
					);
					if (index < 0) {
						setSelectedAddons([...selectedAddons, value]);
					} else {
						setSelectedAddons(
							selectedAddons.filter((ele: any) => ele.addOnId !== value.addOnId)
						);
					}
				}}
				submitData={() => {
					setShowAddon(false);
					if (!!props.service_data.length) {
						addToCart(props.bodyDamageType[0], props.selectedPartDetails);
					} else {
						handleWorkshopQualityOrModel();
					}
				}}
			/>
			<ToastMessage
				showToast={toast.showToast}
				ToastMessage={toast.toastMessage}
				severity={toast.severity}
				onDidDismiss={() => {
					setToast({
						showToast: false,
						toastMessage: "",
						severity: "",
					});
				}}
			/>
		</IonCol>
	);
};

export default connect(
	({
		auth,
		userInfo,
		workshop: {
			vehiclePerspectives,
			damageTypes,
			bodyDamageType,
			selectedPartDetails,
			orientation,
			globalSettings,
		},
		cart: { service_data },
	}: any) => ({
		...auth,
		...userInfo,
		vehiclePerspectives,
		damageTypes,
		bodyDamageType,
		selectedPartDetails,
		orientation,
		service_data,
		globalSettings,
	}),
	{
		getVehiclePerspectives,
		getDamageTypes,
		getBodyDamageTypes,
		clearDamageTypes,
		clearBodyDamageTypes,
		saveSelectedPartDetails,
		saveOrientationOfVehicle,
		addItemToCart,
		getCartItemsList,
	}
)(BodyPanel);
